"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_VIEW_KEYWORDS = exports.LOGIN_REQUEST_URI = exports.OBF_CLIENT_ID_CACHE_KEY = exports.CLIENT_ID_CACHE_KEY = exports.fosCache = exports.Cache = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("../utils");
var Cache = /** @class */ (function () {
    function Cache(config) {
        this.config = (0, tslib_1.__assign)({ keyPrefix: '', storage: window.localStorage, defaultTTL: 259200000 }, config);
        this.setItem = this.setItem.bind(this);
        this.getItem = this.getItem.bind(this);
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    Cache.prototype.setItem = function (key, value) {
        var _a, _b, _c, _d;
        var prefixedKey = ((_a = this.config) === null || _a === void 0 ? void 0 : _a.keyPrefix) + key;
        var currTime = new Date().getTime();
        var item = {
            byteSize: 0,
            data: value,
            expires: ((_c = (_b = this.config) === null || _b === void 0 ? void 0 : _b.defaultTTL) !== null && _c !== void 0 ? _c : 0) + currTime,
            key: prefixedKey,
            priority: 1,
            timestamp: currTime,
            type: typeof value,
            visitedTime: currTime,
        };
        item.byteSize = (0, utils_1.getByteLength)(JSON.stringify(item));
        item.byteSize = (0, utils_1.getByteLength)(JSON.stringify(item));
        (_d = this.config) === null || _d === void 0 ? void 0 : _d.storage.setItem(prefixedKey, JSON.stringify(item));
    };
    Cache.prototype.getItem = function (key) {
        var _a, _b;
        var prefixedKey = ((_a = this.config) === null || _a === void 0 ? void 0 : _a.keyPrefix) + key;
        try {
            var raw = (_b = this.config) === null || _b === void 0 ? void 0 : _b.storage.getItem(prefixedKey);
            if (raw !== null) {
                var parsed = JSON.parse(raw);
                return parsed.data;
            }
            return null;
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.log("Cache getItem failed: ".concat(e));
            return null;
        }
    };
    Cache.prototype.removeItem = function (key) {
        var _a, _b, _c;
        var prefixedKey = ((_a = this.config) === null || _a === void 0 ? void 0 : _a.keyPrefix) + key;
        try {
            var val = (_b = this.config) === null || _b === void 0 ? void 0 : _b.storage.getItem(prefixedKey);
            if (val) {
                (_c = this.config) === null || _c === void 0 ? void 0 : _c.storage.removeItem(prefixedKey);
            }
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.warn("removeItem failed! ".concat(e));
        }
    };
    Cache.prototype.clear = function () {
        var _a, _b, _c, _d;
        var removeKeys = [];
        for (var i = 0; i < ((_a = this.config) === null || _a === void 0 ? void 0 : _a.storage.length); i++) {
            var key = (_b = this.config) === null || _b === void 0 ? void 0 : _b.storage.key(i);
            if (key.indexOf((_c = this.config) === null || _c === void 0 ? void 0 : _c.keyPrefix) === 0) {
                removeKeys.push(key);
            }
        }
        try {
            for (var i = 0; i < removeKeys.length; i += 1) {
                (_d = this.config) === null || _d === void 0 ? void 0 : _d.storage.removeItem(removeKeys[i]);
            }
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.warn("clear failed! ".concat(e));
        }
    };
    return Cache;
}());
exports.Cache = Cache;
exports.fosCache = new Cache({
    keyPrefix: 'FOS_API_',
    storage: window.sessionStorage,
});
exports.CLIENT_ID_CACHE_KEY = 'clientId';
exports.OBF_CLIENT_ID_CACHE_KEY = 'obfuscatedClientId';
exports.LOGIN_REQUEST_URI = 'requestedUri';
exports.SEARCH_VIEW_KEYWORDS = 'keywords';
